// extracted by mini-css-extract-plugin
export var blue = "_1l-h";
export var brand = "_1l-d";
export var darkGrey = "_1l-g";
export var disabled = "_1l-6";
export var disabledSubtle = "_1l-7";
export var error = "_1l-8";
export var green = "_1l-i";
export var grey = "_1l-f";
export var icon = "_1l-0";
export var inherit = "_1l-c";
export var lightGrey = "_1l-e";
export var orange = "_1l-k";
export var pink = "_1l-m";
export var primary = "_1l-1";
export var purple = "_1l-n";
export var quaternary = "_1l-4";
export var quinary = "_1l-5";
export var red = "_1l-l";
export var secondary = "_1l-2";
export var success = "_1l-b";
export var tertiary = "_1l-3";
export var warning = "_1l-9";
export var warningSecondary = "_1l-a";
export var white = "_1l-o";
export var yellow = "_1l-j";